import React, {useEffect, useState} from "react";
import Modal from "@ui-components/Modal";
import Alert from "@ui-components/Alert";
import {useIntl} from "react-intl";
import { TransferCapabilitiesModalProps } from "./types";
import Button from "@ui-components/Button";
import SearchSelect from "@ui-components/SearchSelect";
import { UserWithRoleSchema } from "feature/types";
import Label from "ui-components/Label";
import authenticationService from "@services/AuthenticationService";

/**
 * This modal is used to transfer capabilities of user_account to another user.
 * It can change the chosen user.
 * @param TransferCapabilitiesModalProps
 * @returns 
 */
export const TransferCapabilitiesModal = ({
  contactUsers,
  onConfirm,
  onCancel,
  pendingCapabilitiesTransfer,
}: TransferCapabilitiesModalProps) => {
  const intl = useIntl();
  const userData = authenticationService.getUserData();
  const [chosenUser, setChosenUser] = useState<{value:UserWithRoleSchema|null, label:string} | null>({label:"", value: null});
  const [loading, setLoading] = useState<boolean>(false);

  // const alertMessage = pendingCapabilitiesTransfer ? intl.formatMessage({
  //     id: "cancel_pending_transfer_capabilities",
  //   }) :
  //   userData.role_type !== 'contact_user' ?
  //     intl.formatMessage({
  //       id: "transfer_capabilities_warning",
  //       defaultMessage: `L'utente che sceglierai diventerà admin e tu diventerai utente normale.`,
  //     }) : intl.formatMessage({
  //       id: "request_transfer_capabilities_warning",
  //       defaultMessage:
  //     });

  const modalQuestion = pendingCapabilitiesTransfer ?
    intl.formatMessage({
      id: "confirm_cancel_transfer_capabilities",
      defaultMessage: `Sei sicuro di voler annullare la richiesta di promozione ad Admin?`,
    }) :
    userData.role_type !== 'contact_user' ?
      intl.formatMessage({
        id: "confirm_transfer_capabilities",
        defaultMessage: `Scegli quale utente far diventare Admin. L'utente che sceglierai diventerà admin e tu diventerai utente normale.`,
      }) : intl.formatMessage({
        id: "confirm_request_transfer_capabilities",
        defaultMessage: `Sei sicuro di voler richiedere la promozione ad Admin?`,
      });

  return (
    <Modal onExit={onCancel}>
      <div className={"p-5 grid grid-col gap-y-5"}>
        {/*<Alert type={"warning"} text={alertMessage} />*/}
        <>
          {modalQuestion}
          {userData.role_type !== 'contact_user' && !pendingCapabilitiesTransfer &&
            <SearchSelect
              label={intl.formatMessage({
                id: "select-user",
                defaultMessage: "Seleziona un utente",
              })}
              options={contactUsers.map((user) => ({
                value: user,
                label: user.email,
              }))}
              value={chosenUser}
              onChange={(e: { value: UserWithRoleSchema, label: string }) => {
                setChosenUser(e);
              }}
            />
          }
        </>
        <div className={"flex w-full justify-center gap-x-2 "}>
          <Button
            onClick={async () => {
              setLoading(true);
              await onConfirm(chosenUser?.value);
              setLoading(false);
              onCancel();
            }}
            disabled={!chosenUser?.value && userData.role_type !== 'contact_user' && !pendingCapabilitiesTransfer}
            submitting={loading}
          >
            {intl.formatMessage({
              id: "confirm",
              defaultMessage: "Conferma",
            })}
          </Button>
          <Button onClick={onCancel} styleType={"empty"}>
            {intl.formatMessage({
              id: "cancel",
              defaultMessage: "Annulla",
            })}
          </Button>
        </div>
      </div>
    </Modal>
  );
};